import React, { useEffect, useState } from "react";
import ReactHtmlParser from "react-html-parser";
import { user_draft_policies_list } from "../../user/user.api";
import "../policies/tenders.css";
import BreadCrumpBack from "../../../components/navigator/back";

function DraftPolicies(props) {
  const [data, setData] = useState([]);
  const servInstance = process.env.REACT_APP_BASE_URL;
  const result = servInstance?.substring(0, servInstance.length - 4);

  useEffect(() => {
    user_draft_policies_list().then((res) => {
      setData(res?.data || []);
    });
  }, []);

  const handleNav = (linkurl) => {
    if (!linkurl) return;
    let url = linkurl.trim();
    if (/^https?:\/\//i.test(url)) {
      window.open(url, "_blank");
    } else {
      window.open(`//${url}`, "_blank");
    }
  };

  const handleDownloadFile = (fileUrl) => {
    if (!fileUrl) return;
    const fullFileUrl = `${result}${fileUrl}`;
    window.open(fullFileUrl, "_blank");
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return dateStr;
    return d.toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  const isMalayalam = props.state?.language === "ma";

  const activeData = data.filter((item) => {
    if (!item.feedback_last_date) return true;
    const lastDate = new Date(item.feedback_last_date);
    if (isNaN(lastDate.getTime())) return true;
    lastDate.setHours(23, 59, 59, 999);
    return lastDate >= new Date();
  });

  return (
    <>
      <div className="container-fluid event-bg">
        <div className="row m-55">
          <h3>{isMalayalam ? "കരട് നയം" : "Draft Policy"}</h3>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10 col-md-12">
            {activeData.length > 0 ? (
              activeData.map((item, index) => (
                <div
                  className="bg-white p-4 p-md-5 mb-5 text-center rounded"
                  key={index}
                  style={{
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                    border: "1px solid #f0f0f0",
                  }}
                >
                  {/* Title */}
                  <h2
                    className="fw-bold mb-4"
                    style={{
                      fontSize: "28px",
                      color: "#2b2b2b",
                      lineHeight: "1.4",
                    }}
                  >
                    {isMalayalam
                      ? item?.title_ma || item?.title || ""
                      : item?.title || ""}
                  </h2>

                  {/* Description */}
                  {(item?.description || item?.description_ma) && (
                    <div
                      className="mb-4 mx-auto text-secondary"
                      style={{
                        maxWidth: "850px",
                        fontSize: "15px",
                        lineHeight: "1.7",
                        textAlign: "center",
                      }}
                    >
                      {isMalayalam
                        ? ReactHtmlParser(item?.description_ma || item?.description)
                        : ReactHtmlParser(item?.description)}
                    </div>
                  )}

                  {/* Feedback Last Date */}
                  {item?.feedback_last_date && (
                    <p
                      className="mb-4 text-dark"
                      style={{ fontSize: "15px", fontWeight: "400" }}
                    >
                      {isMalayalam
                        ? "അഭിപ്രായം അറിയിക്കേണ്ട അവസാന തീയതി : "
                        : "Last date to submit feedback : "}
                      <strong>{formatDate(item.feedback_last_date)}</strong>
                    </p>
                  )}

                  {/* Read Buttons */}
                  <div className="d-flex justify-content-center align-items-center gap-3 mb-3 flex-wrap">
                    {item?.document_mal && item?.document_mal !== "null" && (
                      <button
                        type="button"
                        className="btn text-white border-0 me-2 mb-2"
                        style={{
                          backgroundColor: "#007bff",
                          borderRadius: "50px",
                          padding: "9px 26px",
                          fontSize: "14px",
                          fontWeight: "500",
                          boxShadow: "0 2px 6px rgba(0,123,255,0.3)",
                        }}
                        onClick={() => handleDownloadFile(item.document_mal)}
                      >
                        {isMalayalam ? "മലയാളം വായിക്കുക" : "Read Malayalam"}
                      </button>
                    )}

                    {item?.document_eng && item?.document_eng !== "null" && (
                      <button
                        type="button"
                        className="btn text-white border-0 ms-2 mb-2"
                        style={{
                          backgroundColor: "#007bff",
                          borderRadius: "50px",
                          padding: "9px 26px",
                          fontSize: "14px",
                          fontWeight: "500",
                          boxShadow: "0 2px 6px rgba(0,123,255,0.3)",
                        }}
                        onClick={() => handleDownloadFile(item.document_eng)}
                      >
                        {isMalayalam ? "ഇംഗ്ലീഷ് വായിക്കുക" : "Read English"}
                      </button>
                    )}
                  </div>

                  {/* Submit Feedback Button */}
                  {item?.feedback_form && item?.feedback_form !== "null" && (
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        type="button"
                        className="btn text-white border-0"
                        style={{
                          backgroundColor: "#1e9f42",
                          borderRadius: "50px",
                          padding: "10px 32px",
                          fontSize: "15px",
                          fontWeight: "500",
                          boxShadow: "0 2px 8px rgba(30,159,66,0.3)",
                        }}
                        onClick={() => handleNav(item.feedback_form)}
                      >
                        {isMalayalam ? "ഫീഡ്‌ബാക്ക് സമർപ്പിക്കുക" : "Submit Feedback"}
                      </button>
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="no-data text-center py-5">
                <img src="resources/img/no1.png" alt="no data" />
                <h4 className="mt-3">No Records Found..!!</h4>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default DraftPolicies;
